import { API_ENDPOINTS } from './Constants';
import { apiFetch } from './apiHelper';

const UserService = {
    getUsers: async (page = 0, size = 10) => {
        const response = await apiFetch(
            `${API_ENDPOINTS.USERS}?page=${page}&size=${size}`,
            {
                method: "GET",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            }
        );

        if (!response.ok) {
            throw new Error("Greška kod dohvaćanja korisnika");
        }

        return await response.json();
    },

    searchUsers: async (query, page = 0, size = 10) => {
        const response = await apiFetch(
            `${API_ENDPOINTS.USERS_SEARCH}?query=${encodeURIComponent(
                query
            )}&page=${page}&size=${size}`,
            {
                method: "GET",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            }
        );

        if (!response.ok) {
            throw new Error("Greška kod pretraživanja korisnika");
        }

        return await response.json();
    },

    getUserDetails: async (username) => {
        const response = await apiFetch(
            `${API_ENDPOINTS.USER_DETAILS}?username=${username}`,
            {
                method: "GET",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
            }
        );

        const data = await response.json();

        if (!response.ok) {
            throw new Error(
                data.message || "Greška kod dohvaćanja detalja korisnika"
            );
        }

        return data;
    },
};

export default UserService;
